// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'
import DashboardIcon from '@mui/icons-material/Dashboard'
import ListIcon from '@mui/icons-material/List'
import FeedIcon from '@mui/icons-material/Feed'
import { RiHome3Line } from 'react-icons/ri'

const adminPages = {
  id: 'pages',
  type: 'group',
  children: [
    {
      id: 'menu-dashboard',
      title: 'Dashboard',
      type: 'item',
      icon: <RiHome3Line />,
      url: '/dashboard',
      breadcrumbs: false,
      subRoutes: ['/dashboard']
    },

    {
      id: 'menu-users',
      title: 'Accounts',
      type: 'item',
      url: '/accounts',
      icon: <AccountCircleOutlinedIcon />,
      breadcrumbs: false,
      subRoutes: ['/accounts', '/user-account']
    },
    {
      id: 'menu-requests',
      title: 'Requests',
      type: 'item',
      url: '/requests',
      icon: <DashboardIcon />,
      breadcrumbs: false,
      subRoutes: [
        '/requests',
        '/add-campaigns',
        '/add-campaigns-from-existing',
        '/detail-campaign',
        '/view-analytics',
        '/edit-campaign'
      ]
    },
    {
      id: 'menu-transactions',
      title: 'Transactions',
      type: 'item',
      url: '/transactions',
      icon: <ListIcon />,
      breadcrumbs: false,
      subRoutes: ['/transactions']
    },
    {
      id: 'menu-feeds',
      title: 'Feeds',
      type: 'item',
      url: '/feeds',
      icon: <FeedIcon />,
      breadcrumbs: false,
      subRoutes: ['/feeds']
    }
  ]
}

export default adminPages
